declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1062622782706826'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const e = 'script'

  // Initialize fbq
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the pixel script
  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  // Initialize with your Pixel ID
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}

// Pre-built event helpers
export const MetaEvents = {
  pageView: () => trackEvent('PageView'),

  viewContent: (contentName?: string, value?: number, currency?: string) =>
    trackEvent('ViewContent', {
      content_name: contentName || 'Tricotin Rentable Kit',
      content_type: 'product',
      value: value || 12.9,
      currency: currency || 'USD',
    }),

  lead: (contentName?: string) =>
    trackEvent('Lead', {
      content_name: contentName || 'Hero CTA Click',
    }),

  addToCart: (value?: number, currency?: string) =>
    trackEvent('AddToCart', {
      content_name: 'Tricotin Rentable Kit',
      content_type: 'product',
      value: value || 12.9,
      currency: currency || 'USD',
      content_ids: ['51109708955926'],
    }),

  initiateCheckout: (value?: number, currency?: string) =>
    trackEvent('InitiateCheckout', {
      content_name: 'Tricotin Rentable Kit',
      value: value || 12.9,
      currency: currency || 'USD',
      num_items: 1,
    }),
}
